var map = {
	"./images/Add-user.svg": "e805",
	"./images/AddressBook.svg": "414c",
	"./images/Angle-down-yellow.svg": "59e6",
	"./images/Angle-down.svg": "37a0",
	"./images/Angle-right.svg": "4217",
	"./images/Binocular.svg": "e852",
	"./images/Bitcoinlogo.svg": "d2d1",
	"./images/Call.svg": "105c",
	"./images/Chat-smile.svg": "4e6c",
	"./images/Chat2.svg": "1234",
	"./images/ChatCircleDots.svg": "73f9",
	"./images/CheckCircle.svg": "6ccb",
	"./images/CheckCircleSolid.svg": "e47e",
	"./images/Clipboard-check.svg": "98c8",
	"./images/Close-Square.svg": "584d",
	"./images/CloseCircleSolid.svg": "c634",
	"./images/Cooking-book.svg": "65f8",
	"./images/Done-circle2.svg": "55b1",
	"./images/Double-check.svg": "56be",
	"./images/Download.svg": "04b4",
	"./images/DownloadedFile.svg": "d570",
	"./images/EnvelopeSimple.svg": "ca99",
	"./images/Error-circle.svg": "7fa7",
	"./images/Left-2.svg": "0f3e",
	"./images/Mail.svg": "ac1a",
	"./images/Plus-Square.svg": "acb7",
	"./images/Plus.svg": "b93a",
	"./images/Shield-user.svg": "0a72",
	"./images/Trash.svg": "8369",
	"./images/Upload2.svg": "2c9d",
	"./images/User.svg": "6dbf",
	"./images/UserFocus.svg": "a886",
	"./images/Video.svg": "eb40",
	"./images/Warning-1-circle.svg": "0f39",
	"./images/account_box.svg": "becb",
	"./images/accounticon.svg": "01f8",
	"./images/accountsetup/account_add.svg": "9131",
	"./images/accountsetup/account_edit.svg": "38b9",
	"./images/accountsetup/account_upload.svg": "57e5",
	"./images/accountsetup/info.svg": "b516",
	"./images/accountsetup/map.svg": "935e",
	"./images/accountsetup/setting.svg": "8bc9",
	"./images/add.svg": "24e9",
	"./images/addplus.svg": "b5d3",
	"./images/android.svg": "b2fa",
	"./images/announcement/arrow.svg": "0251",
	"./images/announcement/notifications.svg": "ed46",
	"./images/announcement/push_pin.svg": "b2f6",
	"./images/arrow-forward.svg": "987b",
	"./images/arrow-to-up.svg": "00cb",
	"./images/arrow-up-blue.svg": "55a2",
	"./images/arrowBack.svg": "d1a8",
	"./images/arrowup.svg": "9236",
	"./images/btn/btn_edit.svg": "3bbb",
	"./images/btn/duplicate.svg": "0126",
	"./images/btn/plus-square.svg": "c9fc",
	"./images/cake.svg": "92da",
	"./images/call_gray.svg": "77ae",
	"./images/camera.svg": "0d5a",
	"./images/campaign_package.svg": "69e2",
	"./images/check-orange.svg": "7e9e",
	"./images/checked.svg": "0226",
	"./images/checkfalse.svg": "5b49",
	"./images/checkper.svg": "5017",
	"./images/checktrue.svg": "c454",
	"./images/clockwise.svg": "9099",
	"./images/close-icon.svg": "9b7f",
	"./images/close.svg": "2930",
	"./images/content_copy.svg": "f34a",
	"./images/cookie.svg": "6f2b",
	"./images/copy.svg": "f84c",
	"./images/createnewrewardsicon.svg": "19d4",
	"./images/credit_card.svg": "9714",
	"./images/cross.svg": "4915",
	"./images/curserclick.svg": "e879",
	"./images/dashboard/baby.svg": "2c39",
	"./images/dashboard/bank.svg": "c339",
	"./images/dashboard/branch.svg": "503b",
	"./images/dashboard/calendar.svg": "182a",
	"./images/dashboard/coin.svg": "51d8",
	"./images/dashboard/export.svg": "bed5",
	"./images/dashboard/file.svg": "3c1e",
	"./images/dashboard/filearrowdown.svg": "dfd3",
	"./images/dashboard/filter.svg": "5aca",
	"./images/dashboard/fire.svg": "f982",
	"./images/dashboard/folder.svg": "f658",
	"./images/dashboard/gender.svg": "984c",
	"./images/dashboard/piggybank.svg": "e8cd",
	"./images/dashboard/pointonhand.svg": "06e2",
	"./images/dashboard/reward.svg": "fc2d5",
	"./images/dashboard/sale.svg": "3c7b",
	"./images/dashboard/sort.svg": "9a8c",
	"./images/dashboard/star.svg": "079c",
	"./images/dashboard/ticket.svg": "4c40",
	"./images/dashboard/totalmember.svg": "2632",
	"./images/dashboard/usersthree.svg": "8d4e",
	"./images/digital_card.svg": "778b",
	"./images/dots-six-vertical.svg": "9804",
	"./images/edit.svg": "b0e3",
	"./images/editdisabled.svg": "3144",
	"./images/empty_doc.svg": "0ff5",
	"./images/empty_img_card.svg": "a499",
	"./images/empty_specific.svg": "a1d7",
	"./images/en.svg": "317c",
	"./images/extensionicon.svg": "ab80",
	"./images/fil022.svg": "abef",
	"./images/file-search.svg": "1f7c",
	"./images/file_plus.svg": "a851",
	"./images/fullscreen.svg": "78be",
	"./images/ghost.svg": "cbf4",
	"./images/gift-box.svg": "88f7",
	"./images/gift.svg": "754a",
	"./images/hi5.svg": "ed83",
	"./images/iPhone-X.svg": "9ee3",
	"./images/ico-import.svg": "a764",
	"./images/icon-accordion-arrow-down.svg": "468d",
	"./images/icon-attachment.svg": "e770",
	"./images/icon-excel.svg": "de88",
	"./images/icon_notification.svg": "5406",
	"./images/icon_smart_target.svg": "7505",
	"./images/img_phone.svg": "1e0b",
	"./images/importfile/done-circle.svg": "c5f2",
	"./images/importfile/download.svg": "59e4",
	"./images/importfile/file-cloud.svg": "a546",
	"./images/importfile/update-time.svg": "7c37",
	"./images/importfile/warning-circle.svg": "6d80",
	"./images/importmembericon.svg": "411d",
	"./images/inactive.svg": "98d3",
	"./images/inbox.svg": "f261",
	"./images/infocircle.svg": "8a49",
	"./images/information.svg": "9d95",
	"./images/ios.svg": "688a",
	"./images/line_gray.svg": "ccc7",
	"./images/lineicon.svg": "83cc",
	"./images/linked.svg": "f0fb",
	"./images/lock.svg": "d3cc",
	"./images/loginTypeIcon/login_type_id_1.svg": "1121",
	"./images/loginTypeIcon/login_type_id_2.svg": "8032",
	"./images/loginTypeIcon/login_type_id_3.svg": "d41d4",
	"./images/loginTypeIcon/login_type_id_4.svg": "bc4c",
	"./images/loginTypeIcon/login_type_id_5.svg": "5cbb7",
	"./images/logo_email.svg": "2aa5",
	"./images/logo_email_disable.svg": "4a36",
	"./images/logo_line.svg": "b3d4",
	"./images/logo_sms.svg": "ed79",
	"./images/logo_sms_disable.svg": "5aef",
	"./images/logouticon.svg": "aabf",
	"./images/mail_gray.svg": "3187",
	"./images/memberdetailicon.svg": "9fd1",
	"./images/memberlevelicon.svg": "4cc7",
	"./images/merchant/check.svg": "c5b2",
	"./images/merchant/check_circle.svg": "4206",
	"./images/merchant/close.svg": "6a66",
	"./images/merchant/handyman.svg": "fde8",
	"./images/merchant/insert_emoticon.svg": "fca7",
	"./images/merchant/not_interested.svg": "16bd",
	"./images/merchant/power.svg": "32ca",
	"./images/merchant/store_mall_directory.svg": "8cc0",
	"./images/merchant/storefront.svg": "f5d2",
	"./images/merchant/subdirectory_arrow_right.svg": "e3ca",
	"./images/messageboxz.svg": "92dd",
	"./images/mobile_email_page.svg": "933a",
	"./images/movie.svg": "99e9",
	"./images/nerver.svg": "3c83",
	"./images/newlogocolored.svg": "e906",
	"./images/notfound/404.svg": "1395",
	"./images/notfound/error-config-banner.svg": "157c",
	"./images/notiicon.svg": "e648",
	"./images/notiwithoutdot.svg": "f63a",
	"./images/office_logo.svg": "b311",
	"./images/ph.svg": "4e44",
	"./images/physical_card.svg": "456f",
	"./images/planreward/Fire.svg": "0cae",
	"./images/planreward/plan_Duplicate.svg": "2fc4",
	"./images/planreward/plan_Trash.svg": "0c63",
	"./images/planreward/plan_edit.svg": "d09e",
	"./images/pocket.svg": "5e96",
	"./images/pointPocket/Share.svg": "0238",
	"./images/pointPocket/Thunder.svg": "7715",
	"./images/pointPocket/UserTwoTonePrimary.svg": "d111",
	"./images/pointPocket/Users.svg": "2d06",
	"./images/pointPocket/Wallet.svg": "9e34",
	"./images/pointadjusticon.svg": "5dc5",
	"./images/pointearnicon.svg": "52ca",
	"./images/privacy/Key.svg": "804a",
	"./images/privacy/privacy_Upload.svg": "7e0a",
	"./images/privacyicon.svg": "53a5",
	"./images/profileicon.svg": "4fc1",
	"./images/red_notice.svg": "2f5a",
	"./images/repeatorg.svg": "0f59",
	"./images/restore.svg": "df52",
	"./images/rewardicon.svg": "65c3",
	"./images/sale.svg": "acf9",
	"./images/selfonboard/chat-smile.svg": "dd8d",
	"./images/selfonboard/close-back.svg": "e4ae6",
	"./images/selfonboard/package.svg": "6a0a",
	"./images/selfonboard/payment.svg": "275c",
	"./images/selfonboard/permission-check.svg": "1b57",
	"./images/selfonboard/permission-close.svg": "fc2d",
	"./images/selfonboard/permission-pass.svg": "f91e",
	"./images/selfonboard/question-blue.svg": "71d4",
	"./images/selfonboard/question.svg": "3afe",
	"./images/selfonboard/selfonboard_info.svg": "8b7c",
	"./images/selfonboard/time.svg": "3e86",
	"./images/setting_permission.svg": "2612",
	"./images/shield.svg": "b324",
	"./images/smartnotify/Sign-out.svg": "d33c",
	"./images/smartnotify/wallpaper.svg": "2fe6",
	"./images/spendingadjusticon.svg": "bd53",
	"./images/statsbox1.svg": "b1fa",
	"./images/statsbox2.svg": "75db",
	"./images/statsbox3.svg": "2718",
	"./images/statsbox4.svg": "1801",
	"./images/targeticon.svg": "5c31",
	"./images/th.svg": "7d6b",
	"./images/theme/Brush.svg": "668d",
	"./images/theme/cheveron-left.svg": "bb5e",
	"./images/theme/cheveron-right.svg": "ead8",
	"./images/theme/history.svg": "3edd",
	"./images/theme/profile.svg": "1c10",
	"./images/theme/rewards.svg": "16f8",
	"./images/themeicon.svg": "893c",
	"./images/thirdparty/Duplicate.svg": "2083",
	"./images/thirdparty/add_circle.svg": "b798",
	"./images/thirdparty/attachment.svg": "b3f1",
	"./images/thirdparty/chain.svg": "5acf",
	"./images/thirdparty/check_account.svg": "bbd7",
	"./images/thirdparty/error.svg": "3094",
	"./images/thirdparty/google.svg": "5776",
	"./images/thirdparty/icon-exten.svg": "1df3",
	"./images/thirdparty/instagram.svg": "b451",
	"./images/thirdparty/lazada.svg": "22b0",
	"./images/thirdparty/line.svg": "04e1",
	"./images/thirdparty/magento.svg": "0d7b",
	"./images/thirdparty/shopee.svg": "9595",
	"./images/thirdparty/third_edit.svg": "f2e2",
	"./images/thirdparty/warning_amber.svg": "af1d",
	"./images/thirdparty/woocommerce.svg": "f91c",
	"./images/thirdparty/zort.svg": "b961",
	"./images/topspender.svg": "b7cd",
	"./images/upload.svg": "ad34",
	"./images/uploaddisabled.svg": "ce39",
	"./images/user_permission.svg": "ae33",
	"./images/userlevel/Alarm-clock.svg": "0e16",
	"./images/userlevel/ArrowLeft_yellow.svg": "5f00",
	"./images/userlevel/Circle.svg": "3fae",
	"./images/userlevel/Crown_Gold.svg": "1304",
	"./images/userlevel/Crown_Platinum.svg": "fe55",
	"./images/userlevel/Crown_Silver.svg": "26c8",
	"./images/userlevel/Crown__Bronze.svg": "60f4",
	"./images/userlevel/Lock.svg": "dd2a",
	"./images/userlevel/Repeat.svg": "f4c3",
	"./images/userlevel/Sharp_Bronze.svg": "fbbd",
	"./images/userlevel/Sharp_Gold.svg": "44b7",
	"./images/userlevel/Sharp_Orange.svg": "575d",
	"./images/userlevel/Sharp_Platinum.svg": "18d7",
	"./images/userlevel/Sharp_Silver.svg": "0067",
	"./images/userlevel/Stairs.svg": "0a2d",
	"./images/userlevel/Star_Bronze.svg": "4424",
	"./images/userlevel/Star_Gold.svg": "f1a2",
	"./images/userlevel/Star_Platinum.svg": "acd0",
	"./images/userlevel/Star_Silver.svg": "4a49",
	"./images/userlevel/Stop.svg": "4def",
	"./images/userlevel/Trash_Red.svg": "a4e0",
	"./images/userlevel/add_blue.svg": "bf5b",
	"./images/userlevel/arrow_back.svg": "fef9",
	"./images/userlevel/arrow_forward.svg": "1c7c",
	"./images/userlevel/arrow_forward_color_orange.svg": "1be2",
	"./images/userlevel/brightness_low.svg": "e811",
	"./images/userlevel/edit_gray.svg": "7ce8",
	"./images/userlevel/edit_orange.svg": "e5c6",
	"./images/userlevel/filter_list.svg": "8819",
	"./images/userlevel/icon_bz.svg": "b998",
	"./images/userlevel/loupe.svg": "b570",
	"./images/userlevel/radio_active.svg": "d80a",
	"./images/userlevel/radio_inactive.svg": "3e7c",
	"./images/userlevel/userlevel_Trash.svg": "8c14",
	"./images/userlevel/userlevel_edit.svg": "8400",
	"./images/userlevel/warning.svg": "594c",
	"./images/userlevel/white_plus.svg": "0c58",
	"./images/usernamaulicon.svg": "0c8d",
	"./images/userpermissionicon.svg": "a3a9",
	"./images/website.svg": "47fa"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "15f4";